import React, { useState, useEffect } from "react";
import Table from "../components/Table";
import TableSorting from "../components/TableSorting";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import filePDF from "../assets/images/file-pdf.svg";
import api from "../utils/api";
import FundsCard from "../components/FundsCard";
import ObjectiveBox from "../components/ObjectiveBox";
import Leaderslist from "../components/Leaderslist";
import PdfDownloader from "../components/PdfDownloader";
import defaultLogo from "../assets/images/image.png";
import ErrorComp from "../components/ErrorComp";

const FinancePension = (props) => {
  const [tableHeader, setTableHeader] = useState(
    window.innerWidth < 767
      ? [
          { label: "חברה", sortable: false, engTrns: "logo" },
          { label: "שם מוצר", sortable: false, engTrns: "field1" },
          { label: "", sortable: false, engTrns: "field12" },
          { label: "מספר פוליסה", sortable: true, engTrns: "field2" },
          { label: "סטטוס", sortable: true, engTrns: "field3" },
          { label: "סך הכל חסכון", sortable: true, engTrns: "field4" },
          { label: "תחנת משיכה קרובה", sortable: false, engTrns: "field5" },
          { label: "שיעור דמי ניהול", sortable: false, engTrns: "field6" },
          { label: "סך הכל דמי ניהול", sortable: false, engTrns: "field7" },
          { label: "תשואה מתחילת השנה", sortable: false, engTrns: "field8" },
          { label: "הפקדות חוסך", sortable: false, engTrns: "field19" },
          { label: "הפקדות מעסיק", sortable: false, engTrns: "field10" },
          { label: "תאריך הצטרפות", sortable: false, engTrns: "field11" },
          { label: "תאריך נכונות", sortable: false, engTrns: "field12" },
        ]
      : [
          { label: "חברה", sortable: false, engTrns: "logo" },
          { label: "שם מוצר", sortable: false, engTrns: "field1" },
          { label: "מספר פוליסה", sortable: true, engTrns: "field2" },
          { label: "סטטוס", sortable: true, engTrns: "field3" },
          { label: "סך הכל חסכון", sortable: true, engTrns: "field4" },
          { label: "תחנת משיכה קרובה", sortable: false, engTrns: "field5" },
          { label: "שיעור דמי ניהול", sortable: false, engTrns: "field6" },
          { label: "סך הכל דמי ניהול", sortable: false, engTrns: "field7" },
          { label: "תשואה מתחילת השנה", sortable: false, engTrns: "field8" },
          { label: "הפקדות חוסך", sortable: false, engTrns: "field19" },
          { label: "הפקדות מעסיק", sortable: false, engTrns: "field10" },
          { label: "תאריך הצטרפות", sortable: false, engTrns: "field11" },
          { label: "תאריך נכונות", sortable: false, engTrns: "field13" },
          { label: "", sortable: false, engTrns: "field12" },
        ]
  );
  const [data, setData] = useState(null);
  const [pensionData, setPensionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tableHeaderSort, setTableHeaderSort] = useState([
    { key: "name", label: "שם הקופה" },
    { key: "monthly", label: "חודשי" },
    { key: "monthly_sum", label: "12 חודשים אחרונים" },
    { key: "threeYears", label: "3 שנים" },
    { key: "fiveYears", label: "5 שנים" },
    {
      key: "depositmanagementfee",
      label: "דמי ניהול ממוצעים",
      tooltip: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה.",
    },
    {
      key: "propertymanagementfees",
      label: "שארפ 5 שנים ",
      tooltip: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה.",
    },
    {
      key: "totalAssets",
      label: "היקף נכסים",
      tooltip: "Lorem Ipsum הוא פשוט טקסט דמה של תעשיית הדפוס והקביעה.",
    },
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // setPensionData((props?.pensionPolicies || []).filter((item) => item?.duplicate !== true));
        setPensionData((props?.pensionPolicies || []));
        setData(
          (props?.pensionPolicies || [])
            .filter(
              (elem) =>
                !["2", "6", "7", "1", "8"].includes(elem?.productType || "")
            ) || []
        );
      } catch (err) {
        console.error("error", err);
      } finally {
        if (props?.onboardingStep >= 4) {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [props?.pensionPolicies, props?.onboardingStep]);

  const [leadsData, setLeadsData] = useState([]);
  const [yieldData, setYieldData] = useState([]);
  const [yieldDataFirst, setYieldDataFirst] = useState([]);
  const [yieldDataSecond, setYieldDataSecond] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const leadsData1 = [
          {
            title: "קרנות הפנסיה המובילות",
            subtitle: "מוביל בתשואה 12 חודשים",
            leads:
              props?.yieldsAll?.[0]?.yields_pension?.map((item, index) => ({
                image: defaultLogo,
                description: item?.FUND_NAME || "-",
                classification: item?.FUND_CLASSIFICATION,
                percentage: `${item?.MONTHLY_YIELD || 0}%`,
              })) || [],
          },
          {
            title: "קרנות השתלמות המובילות",
            subtitle: "מוביל בתשואה 12 חודשים",
            leads:
              props?.yieldsAll?.[2]?.yields_gemel?.map((item, index) => ({
                image: defaultLogo,
                description: item?.FUND_NAME || "-",
                percentage: `${item?.MONTHLY_YIELD || 0}%`,
              })) || [],
          },
          {
            title: "פוליסות חיסכון מובילות",
            subtitle: "מוביל בתשואה 12 חודשים",
            leads:
              props?.yieldsAll?.[0]?.yields_gemel?.map((item, index) => ({
                image: defaultLogo,
                description: item?.FUND_NAME || "-",
                percentage: `${item?.MONTHLY_YIELD || 0}%`,
              })) || [],
          },
        ];
        setLeadsData(leadsData1);
        setYieldData(props?.yieldsAll?.yields || []);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [props?.yieldsAll]);

  const yielddata = async () => {
    try {
      const UserProfile = await api.get("/policy/yield-data");
      if (UserProfile?.status === 200) {
        setYieldDataFirst(UserProfile?.data?.data || []);
        setYieldDataSecond(UserProfile?.data?.dataFund2 || []);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    yielddata();
  }, []);

  const [UserData, setUserData] = useState({});
  const getUser = async () => {
    setUserData(props?.data || {});
  };

  useEffect(() => {
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/register"
    ) {
      getUser();
    }
  }, [props?.data]);

  return (
    <>
      <div className="heading-wrap d-flex justify-content-between">
        <div className="heading">
          <div className="head-wrap">
            <Breadcrumbs className="breadcrumbs" aria-label="breadcrumb">
              <Link to="/profile" underline="hover">
                {UserData?.full_name || ""}
              </Link>
              <Typography>
                <b>פיננסים</b>
              </Typography>
            </Breadcrumbs>
            <h1>ברוכים השבים , {UserData?.full_name || ""}</h1>
          </div>
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="financepension.pdf">
              <img src={filePDF} alt="" />
            </PdfDownloader>
          </div>
          <p>
            ברוכים הבאים ללוח הבקרה הפיננסי שלכם! כאן תוכלו לגלות את כל המידע
            הדרוש לתכנון ולניהול של הפרישה שלכם!
            <br />
            עמוד זה מציע מבט מקיף על המצב הכלכלי שלכם, תוכלו להבין כמה כסף צברתם
            עד היום, כמה מתוכו נמצא בקרנות הפנסיה וקופות הגמל, חסכון וכו׳.
            <br />
            בנוסף תוכלו לקבל תמונה מקיפה על הקצבאות והצבירות בחשבונות שלכם,
            חסכונות והשקעות. תקבלו תובנות חשובות על נתוני הפנסיה, תזהו הזדמנויות
            לחיסכון נוסף ותוכלו לעקוב אחר ההתקדמות שלכם לעבר היעדים הפיננסיים.
            עם טיפים מותאמים אישית ותצוגה ברורה של הנתונים הכלכליים שלכם, תוכלו
            לקבל החלטות מושכלות ולשלוט בעתיד הפיננסי שלכם.
          </p>
        </div>
        <div className="btns-row">
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="financepension.pdf">
              <img src={filePDF} alt="" /> הפקת דוח
            </PdfDownloader>
          </div>
        </div>
      </div>
      {props?.onboarding_error == 1 && <ErrorComp />}
      <FundsCard
        pensionData={pensionData}
        from="finance"
        onboardingStep={props?.onboardingStep}
        balances={props?.balances}
      />
      <div className="finance_table">
        <Table
          tableHeader={tableHeader}
          data={data}
          from="financePension"
          title="פוליסות"
          loading={loading}
          notFoundMessage="לממן"
          carrierLogos={props?.carrierLogos}
        />
      </div>

      {/* <div className="table-main">
        <div className="title">
          <h3>פוליסות גמל וחיסכון מובילות</h3>
        </div>
        <div className="objective-box d-flex">
            <div className="table-main-left">
              <TableSorting
                leadsData={yieldData}
                yieldDataFirst={yieldDataFirst}
                tableHeaderSort={tableHeaderSort}
                from="PensionPage"
              />
            </div>
          <div className="box-main">
            <ObjectiveBox loading={false} />
          </div>
        </div>
      </div> */}
      {/* <div className="table-main">
        <div className="title d-flex justify-content-between">
          <h2>קופות מקיפות מובילות</h2>
        </div>
        <div className="objective-box d-flex">
          <div className="table-main-left w_100">
            <>
              <TableSorting
                yieldDataFirst={yieldDataFirst}
                tableHeaderSort={tableHeaderSort}
                from="PensionPage"
              />
            </>
          </div>
        </div>
      </div>
      <div className="table-main">
        <div className="title d-flex justify-content-between">
          <h2>קופות משלימות מובילות</h2>
        </div>
        <div className="objective-box d-flex">
          <div className="table-main-left w_100">
            <>
              <TableSorting
                yieldDataFirst={yieldDataSecond}
                tableHeaderSort={tableHeaderSort}
                from="PensionPage"
              />
            </>
          </div>
        </div>
      </div> */}

      <Leaderslist leadsData={leadsData} loading={false} />
    </>
  );
};

export default FinancePension;
